import axios from '@app/config/axios.config';

type GetPersonneMoralesParams = {
    page: number;
    limit: number;
    search: string;
    sort_by: string;
    asc: boolean;
};

export type PersonneMorale = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    raisonSociale: string;
    telephone: string;
    email: string;
    notes: string;
    logoPath: string;
    type: string;
    status: 'actif' | 'inactif';
    adresse?: {
        ligne1?: string | null;
        ligne2?: string | null;
        ville?: string | null;
        casePostal?: number | null;
        NPA?: number | null;
        region?: string | null;
        pays?: string | null;
    } | null;
};

export type Parrainage = {
    id: number;
    montantPromesse: number;
    facture: {
        numeroFacture: string;
        montantPayeHorsTva: number;
        paiement: boolean;
    };
    mandat: {
        ref: string;
        club: {
            nom: string;
        };
    };
    collaborateur: {
        prenom: string;
        nom: string;
    };
};

export const getPersonneMorales = async (
    params: GetPersonneMoralesParams
): Promise<{ personneMorales: PersonneMorale[]; totalCount: number }> => {
    try {
        const res = await axios.get('/personnesMorales', { params });
        return res.data;
    } catch (err) {
        console.error(err);
        return { personneMorales: [], totalCount: 0 };
    }
};

export const getPersonneMoraleById = async (id: string) => {
    return await axios.get(`/personnesMorales/${id}`);
};

export type CreatePersonneMoralesBody = {
    nom: string;
    sport: string;
    adresse: string;
};

export const createPersonneMorale = async (
    body: CreatePersonneMoralesBody
): Promise<{ personneMorales: PersonneMorale }> => {
    return await axios.post('/personnesorales', body);
};

// Fonctions pour la réaffectation de parrainages
export const getParrainagesByPersonneMorale = async (
    id: number
): Promise<Parrainage[]> => {
    try {
        const res = await axios.get(`/personnesMorales/${id}/parrainages`);
        return res.data;
    } catch (err) {
        console.error(err);
        return [];
    }
};

export const reassignParrainages = async (
    factureNumbers: string[],
    personneMoraleId: number
): Promise<any> => {
    try {
        const res = await axios.post('/personnesMorales/reassign-parrainages', {
            factureNumbers,
            personneMoraleId,
        });
        return res.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const deaffectParrainage = async (
    parrainageId: number
): Promise<any> => {
    try {
        const res = await axios.post(
            `/personnesMorales/deaffect-parrainage/${parrainageId}`
        );
        return res.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
};
